import { polyLine2Compare, polyLine2ReflectOverYAxis } from "geom/polyLine2";
import { polyLine2New } from "geom/polyLine2Types";
import type { DocMigration } from "../docMigration";

enum ProfileExtrusionType {
  NONE = "NONE",
  DEFAULT_PROFILE = "DEFAULT_PROFILE",
  EXTERIOR_TRANSITION_BOARD_TRIM_PROFILE = "EXTERIOR_TRANSITION_BOARD_TRIM_PROFILE",
  DRIP_CAP_PROFILE = "DRIP_CAP_PROFILE",
  ROWLOCK_BRICK = "ROWLOCK_BRICK",
  ROWLOCK_OVER_SOLDIER_BRICK = "ROWLOCK_OVER_SOLDIER_BRICK",
  TRIM_BOARD_1_2 = "TRIM_BOARD_1_2",
  TRIM_BOARD_1_3 = "TRIM_BOARD_1_3",
  TRIM_BOARD_1_4 = "TRIM_BOARD_1_4",
  TRIM_BOARD_1_6 = "TRIM_BOARD_1_6",
  TRIM_BOARD_1_8 = "TRIM_BOARD_1_8",
  TRIM_BOARD_1_10 = "TRIM_BOARD_1_10",
  TRIM_BOARD_1_12 = "TRIM_BOARD_1_12",
  TRIM_REVEAL_1 = "TRIM_REVEAL_1",
  TRIM_CAP_1_2 = "TRIM_CAP_1_2",
  TRIM_VERT_1_60 = "TRIM_VERT_1_60",
  CROWN_4_FRIEZE_6 = "CROWN_4_FRIEZE_6",
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_34: DocMigration = {
  maxSchemaVersion: "0.0.34",
  apply(json: any) {
    const facades = json.facades;
    if (facades) {
      const profileExtrusionTypes = Object.values(ProfileExtrusionType);
      for (const facadeKey in facades) {
        const facade = facades[facadeKey];
        if (facade?.sweepStrata) {
          for (const trimKey in facade.sweepStrata) {
            const trim = facade.sweepStrata[trimKey];
            const { sweep } = trim;
            const profileName = sweep.profileName;
            const index = profileExtrusionTypes.indexOf(profileName);
            if (index === -1) {
              sweep["profileId"] = getProfileTypeFromPolyLine(sweep.profile);
            } else {
              sweep["profileId"] = profileExtrusionTypes[index];
            }
            if (!sweep["elevationNoteEnabled"]) {
              sweep["elevationNoteEnabled"] = false;
            }
            if (!sweep["elevationNoteOverride"]) {
              sweep["elevationNoteOverride"] = null;
            }
            if (!sweep["bomDescriptionOverride"]) {
              sweep["bomDescriptionOverride"] = null;
            }
            delete sweep["profile"];
            delete sweep["profileName"];
          }
        }
      }
    }
    return json;
  },
};

function getProfileTypeFromPolyLine(source: number[]): string {
  for (const key in ProfileExtrusionType) {
    const profile = LegacyProfileTable[key];
    if (profile && polyLine2Compare(polyLine2New(source), profile)) {
      return key;
    }
  }
  return ProfileExtrusionType.EXTERIOR_TRANSITION_BOARD_TRIM_PROFILE;
}

//used for migrations
const LegacyProfileTable = {
  ["EXTERIOR_TRANSITION_BOARD_TRIM_PROFILE"]: polyLine2New([0, 0, 0, 4, 0.75, 4, 0.75, -4, 0, -4, 0, 0]),
  ["DRIP_CAP_PROFILE"]: polyLine2New([0, 0, 0, 0.5, 1, 0.5, 1, 0, 0, 0, 0, 0]),
  ["ROWLOCK_BRICK"]: polyLine2New([0, 0, 1, 0, 1, -3.5, 0, -3.5, 0, 0]),
  ["ROWLOCK_OVER_SOLDIER_BRICK"]: polyLine2New([0, 0, 2, 0, 2, -3.5, 1, -3.5, 1, -11, 0, -11, 0, 0]),
  ["TRIM_BOARD_1_2"]: polyLine2New([0, 0, 0, 1, 0.75, 1, 0.75, -1, 0, -1, 0, 0]),
  ["TRIM_BOARD_1_3"]: polyLine2New([0, 0, 0, 1.5, 0.75, 1.5, 0.75, -1.5, 0, -1.5, 0, 0]),
  ["TRIM_BOARD_1_4"]: polyLine2New([0, 0, 0, 2, 0.75, 2, 0.75, -2, 0, -2, 0, 0]),
  ["TRIM_BOARD_1_6"]: polyLine2New([0, 0, 0, 3, 0.75, 3, 0.75, -3, 0, -3, 0, 0]),
  ["TRIM_BOARD_1_8"]: polyLine2New([0, 0, 0, 4, 0.75, 4, 0.75, -4, 0, -4, 0, 0]),
  ["TRIM_BOARD_1_10"]: polyLine2New([0, 0, 0, 5, 0.75, 5, 0.75, -5, 0, -5, 0, 0]),
  ["TRIM_BOARD_1_12"]: polyLine2New([0, 0, 0, 6, 0.75, 6, 0.75, -6, 0, -6, 0, 0]),
  ["TRIM_REVEAL_1"]: polyLine2New([0, 0, 0, 0.5, 1, 0.5, 1, -0.5, 0, -0.5, 0, 0]),
  ["TRIM_CAP_1_2"]: polyLine2New([0, 0, 0, 3, 1.5, 3, 1.5, 0, 0, 0, 0, 0]),
  ["TRIM_VERT_1_60"]: polyLine2New([0, 0, 0, 60, 0.75, 60, 0.75, 0, 0, 0, 0, 0]),
  ["CROWN_4_FRIEZE_6"]: polyLine2ReflectOverYAxis(
    polyLine2New([
      0, 0, -3.357881, 0, -3.357881, -0.76815, -2.800829, -1.194753, -2.539932, -1.903407, -1.968778, -2.312381,
      -1.968778, -2.664945, -1.556278, -2.83065, -1.439932, -3.285458, -0.75, -3.285458, -0.75, -7.5, 0, -7.5, 0, 0,
    ]),
  ),
};

export default migration_0_0_34;
